"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.MinimumInputLength = void 0;
var MinimumInputLength = function (target) {
    return /** @class */ (function (_super) {
        __extends(MinimumInputLength, _super);
        function MinimumInputLength() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        MinimumInputLength.prototype.query = function (params, callback) {
            this.minimumInputLength = this.options.get('minimumInputLength');
            params.term = params.term || '';
            if (params.term.length < this.minimumInputLength) {
                this.trigger('results:message', {
                    message: 'inputTooShort',
                    args: {
                        minimum: this.minimumInputLength,
                        input: params.term,
                        params: params
                    }
                });
                return;
            }
            _super.prototype.query.call(this, params, callback);
        };
        return MinimumInputLength;
    }(target));
};
exports.MinimumInputLength = MinimumInputLength;
//# sourceMappingURL=minimum-input-length.js.map